import { createTheme, responsiveFontSizes } from '@material-ui/core/styles'
import './App.css'

let theme = createTheme({
  palette: {
    primary: {
      light: '#6ec6ff',
      dark: '#0069c0',
      main: '#2196f3',
      contrastText: '#ffffff'
    },
    secondary: {
      light: '#ffc947',
      dark: '#c66900',
      main: '#ff9800',
      contrastText: '#ffffff'
    }
  },

  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(',') 
}})

theme = responsiveFontSizes(theme)

export default theme